import React, { useState } from 'react';
import './SoulmateForm.css';

const SoulmateForm = ({ onSubmit, loading }) => {
  const [formData, setFormData] = useState({
    name: '',
    birth_place: '',
    birth_date: '',
    birth_time: '',
    user_gender: '',
    interested_in: '',
  });

  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    }

    if (!formData.birth_place.trim()) {
      newErrors.birth_place = 'Birth location is required';
    }

    if (!formData.birth_date) {
      newErrors.birth_date = 'Birth date is required';
    }

    if (!formData.birth_time) {
      newErrors.birth_time = 'Birth time is required';
    }

    if (!formData.user_gender) {
      newErrors.user_gender = 'Please select your gender';
    }

    if (!formData.interested_in) {
      newErrors.interested_in = 'Please select who you are interested in';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    // Combine date and time into ISO format
    const birth_date_time = `${formData.birth_date}T${formData.birth_time}:00`;

    const submitData = {
      name: formData.name.trim(),
      birth_place: formData.birth_place.trim(),
      birth_date_time: birth_date_time,
      user_gender: formData.user_gender,
      interested_in: formData.interested_in
    };

    onSubmit(submitData);
  };

  return (
    <div className="soulmate-form-container">
      <form onSubmit={handleSubmit} className="soulmate-form">
        <h2>Tell us about yourself</h2>
        
        <div className="form-group">
          <label htmlFor="name">Your Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            placeholder="Enter your full name"
            className={errors.name ? 'error' : ''}
          />
          {errors.name && <span className="error-message">{errors.name}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="birth_place">Birth Location</label>
          <input
            type="text"
            id="birth_place"
            name="birth_place"
            value={formData.birth_place}
            onChange={handleInputChange}
            placeholder="e.g., New York, NY or London, England"
            className={errors.birth_place ? 'error' : ''}
          />
          {errors.birth_place && <span className="error-message">{errors.birth_place}</span>}
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="birth_date">Birth Date</label>
            <input
              type="date"
              id="birth_date"
              name="birth_date"
              value={formData.birth_date}
              onChange={handleInputChange}
              className={errors.birth_date ? 'error' : ''}
            />
            {errors.birth_date && <span className="error-message">{errors.birth_date}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="birth_time">Birth Time</label>
            <input
              type="time"
              id="birth_time"
              name="birth_time"
              value={formData.birth_time}
              onChange={handleInputChange}
              className={errors.birth_time ? 'error' : ''}
            />
            {errors.birth_time && <span className="error-message">{errors.birth_time}</span>}
          </div>
        </div>

        <div className="form-group">
          <label>I am...</label>
          <div className="radio-group">
            <label className="radio-option">
              <input
                type="radio"
                name="user_gender"
                value="man"
                checked={formData.user_gender === 'man'}
                onChange={handleInputChange}
              />
              <span>Man</span>
            </label>
            <label className="radio-option">
              <input
                type="radio"
                name="user_gender"
                value="woman"
                checked={formData.user_gender === 'woman'}
                onChange={handleInputChange}
              />
              <span>Woman</span>
            </label>
          </div>
          {errors.user_gender && <span className="error-message">{errors.user_gender}</span>}
        </div>

        <div className="form-group">
          <label>Interested in...</label>
          <div className="radio-group">
            <label className="radio-option">
              <input
                type="radio"
                name="interested_in"
                value="men"
                checked={formData.interested_in === 'men'}
                onChange={handleInputChange}
              />
              <span>Men</span>
            </label>
            <label className="radio-option">
              <input
                type="radio"
                name="interested_in"
                value="women"
                checked={formData.interested_in === 'women'}
                onChange={handleInputChange}
              />
              <span>Women</span>
            </label>
          </div>
          {errors.interested_in && <span className="error-message">{errors.interested_in}</span>}
        </div>

        <button 
          type="submit" 
          className="submit-button"
          disabled={loading}
        >
          {loading ? 'Consulting the Stars...' : '✨ Find My Soulmate'}
        </button>

        <p className="disclaimer">
          Your birth time is important for accurate astrological calculations. 
          If you don't know your exact birth time, call and ask your parents.
          You should probably call them anyway, they miss you! 😊
        </p>
      </form>
    </div>
  );
};

export default SoulmateForm;